import { ListAllProcessesRequestSchema, ListAllProcessesResponseSchema } from './list-all-processes.schema';
/**
 * List All Processes Endpoint Contract
 * Retrieves all processes in the system
 */ export const listAllProcessesContract = {
    method: 'GET',
    path: '/api/v2/process',
    description: 'Retrieve all processes in the system',
    requestSchema: ListAllProcessesRequestSchema,
    responseSchema: ListAllProcessesResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=list-all-processes.contract.js.map